import { BASE_PATH_B2B } from '../constants'

export function getBasePath(pathname: string): string {
  if (pathname.startsWith('/cadastro/b2b') || pathname.startsWith('/login/b2b')) {
    return BASE_PATH_B2B
  }
  return ''
}
